import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { MainComponent } from './shared/components/main';
import { NoPermissionComponent } from './shared/components/no-permission/no-permission/no-permission.component';

export const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    canActivate: [MsalGuard],
    children: [
      {
        path: 'recipe',
        loadChildren: () =>
          import('./modules/recipe/recipe.module').then((m) => m.RecipeModule),
      },
      {
        path: 'library',
        loadChildren: () =>
          import('./modules/library/library.module').then(
            (m) => m.LibraryModule,
          ),
      },
      {
        path: 'setting',
        loadChildren: () =>
          import('./modules/settings/settings.module').then(
            (m) => m.SettingsModule,
          ),
      },
      {
        path: 'unauthorized',
        component: NoPermissionComponent,
      },
    ],
  },
  {
    path: '',
    redirectTo: 'recipe',
    pathMatch: 'full',
  },
];
